<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>cloud_download</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Base IVR</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <v-col cols="6" lg="3">
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="listEmpresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Créditos de la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col cols="6" lg="3">
            <!-- <v-autocomplete v-model="filtro.sucursalId" :items="listSucursales" autocomplete="disabled"
                            item-text="nombre" item-value="id" label="de la Sucursal" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete> -->

            <v-flex>
              <v-select
                label="canal de venta:"
                v-model="filtro.canalesVentaIds"
                :items="listTiposCanalVenta"
                item-text="descripcion"
                item-value="id"
                multiple>
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggleCanales">
                    <v-list-item-action>
                      <v-icon
                        :color="
                          filtro.canalesVentaIds.length > 0
                            ? 'indigo darken-4'
                            : ''
                        "
                        >{{ iconSucursales }}</v-icon
                      >
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Marcar todas</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <!-- ARRIBA esto es para agregar la opción de select all -->
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index <= 2">
                    <span>{{ item.descripcion }}</span>
                  </v-chip>
                  <span v-if="index === 3" class="grey--text caption"
                    >(+{{ filtro.canalesVentaIds.length - 3 }} más)</span
                  >
                </template>
              </v-select>
            </v-flex>
          </v-col>
          <v-col cols="6" lg="3">
            <!-- <v-autocomplete v-model="filtro.productoId" :items="listProductos" autocomplete="disabled"
                            item-text="descripcion" item-value="id" label="del Producto" placeholder="Seleccione uno" :menu-props="{minWidth:'400'}"></v-autocomplete> -->

            <v-flex>
              <v-select
                label="del Producto:"
                v-model="filtro.productosIds"
                :items="listProductos"
                item-text="descripcion"
                item-value="id"
                multiple>
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggleProductos">
                    <v-list-item-action>
                      <v-icon
                        :color="
                          filtro.productosIds.length > 0
                            ? 'indigo darken-4'
                            : ''
                        "
                        >{{ iconProductos }}</v-icon
                      >
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Marcar todos</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <!-- ARRIBA esto es para agregar la opción de select all -->
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index <= 2">
                    <span>{{ item.descripcion }}</span>
                  </v-chip>
                  <span v-if="index === 3" class="grey--text caption"
                    >(+{{ filtro.productosIds.length - 3 }} más)</span
                  >
                </template>
              </v-select>
            </v-flex>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="4">
            <v-radio-group
              v-model="filtro.porFecha"
              :mandatory="true"
              row
              label="Fecha de">
              <v-radio value="1">
                <div slot="label">1er. Vto. Impago</div>
              </v-radio>
              <v-radio value="2">
                <div slot="label">Liquidación</div>
              </v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="filtro.fechaDesde"
              label="Desde"
              type="date"
              prepend-icon="event"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="filtro.fechaHasta"
              label="Hasta"
              type="date"
              prepend-icon="event"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="2">
            <v-text-field
              v-model="filtro.fechaPagoDesde"
              label="Fecha Pago Desde"
              type="date"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="filtro.fechaPagoHasta"
              label="Fecha Pago Hasta"
              type="date"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="filtro.vectorMoraDesde"
              label="Vector Mora Desde"
              type="number"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="filtro.vectorMoraHasta"
              label="Vector Mora Hasta"
              type="number"></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-radio-group v-model="filtro.acuerdo" :mandatory="true" row>
              <v-radio value="0">
                <div slot="label">Con o Sin Acuerdo</div>
              </v-radio>
              <v-radio value="1">
                <div slot="label">Sólo Sin Acuerdo</div>
              </v-radio>
              <v-radio value="2">
                <div slot="label">Sólo Con Acuerdo</div>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="2">
            <v-switch
              label="Filtrar Por Archivo"
              v-model="filtro.porArchivo"></v-switch>
          </v-col>
          <v-col v-if="filtro.porArchivo"> </v-col>
        </v-row>

        <span class="title" v-if="filtro.porArchivo">
          Archivo de Filtro Adicional</span
        >
        <v-divider></v-divider>

        <v-row align="center" v-if="filtro.porArchivo">
          <v-col>
            <v-file-input
              v-model="archivoFiltroOperaciones"
              placeholder="Seleccione el archivo Excel"
              label="Archivo Filtro"
              prepend-icon="mdi-paperclip">
            </v-file-input>
          </v-col>
          <v-col>
            <!-- <v-btn @click="traerListaOperacionesDeExcel()">
              Cargar Filtro
            </v-btn> -->
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="2">
            <v-switch
              label="Filtrar Por Estudio"
              v-model="filtro.porEstudio"></v-switch>
          </v-col>
          <v-col v-if="filtro.porEstudio">
            <v-select
              v-model="filtro.estudios"
              :items="listEstudios"
              autocomplete="disabled"
              multiple
              item-text="descripcion"
              item-value="id"
              label="en Estudio"
              placeholder="Seleccione uno"
              :menu-props="{ minWidth: '400' }"></v-select>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="2">
            <v-switch
              label="Filtrar 1er Vto. Acuerdo"
              v-model="filtro.porVencimientoAcuerdo"></v-switch>
          </v-col>
          <v-col cols="2" v-if="filtro.porVencimientoAcuerdo">
            <v-text-field
              v-model="filtro.fechaVencimientoAcuerdoDesde"
              label="Desde"
              type="date"
              prepend-icon="event"></v-text-field>
          </v-col>
          <v-col cols="2" v-if="filtro.porVencimientoAcuerdo">
            <v-text-field
              v-model="filtro.fechaVencimientoAcuerdoHasta"
              label="Hasta"
              type="date"
              prepend-icon="event"></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="2">
            <v-switch
              label="Filtrar por Capital"
              v-model="filtro.porCapital"></v-switch>
          </v-col>
          <v-col cols="2" v-if="filtro.porCapital">
            <v-text-field
              v-model="filtro.capitalDesde"
              label="Desde"></v-text-field>
          </v-col>
          <v-col cols="2" v-if="filtro.porCapital">
            <v-text-field
              v-model="filtro.capitalHasta"
              label="Hasta"></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="2">
            <v-switch
              label="Filtrar por Día de Cobro"
              v-model="filtro.porDiaCobro"></v-switch>
          </v-col>
          <v-col cols="2" v-if="filtro.porDiaCobro">
            <v-text-field
              v-model="filtro.diaCobroDesde"
              label="Desde"></v-text-field>
          </v-col>
          <v-col cols="2" v-if="filtro.porDiaCobro">
            <v-text-field
              v-model="filtro.diaCobroHasta"
              label="Hasta"></v-text-field>
          </v-col>
        </v-row>

        <span class="title">Opciones</span>
        <v-divider></v-divider>
        <v-row dense>
          <v-col cols="4">
            <v-radio-group
              v-model="filtro.tipoTelefonoId"
              :mandatory="true"
              row>
              <v-radio value="2">
                <div slot="label">Todos</div>
              </v-radio>
              <v-radio value="0">
                <div slot="label">Fijo</div>
              </v-radio>
              <v-radio value="1">
                <div slot="label">Celular</div>
              </v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="filtro.perteneceAId"
              :items="listPerteneceA"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Pertenece A"
              placeholder="Seleccione uno"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col cols="2" lg="1">
            <v-text-field
              v-model="filtro.separador"
              label="Separador en archivo"></v-text-field>
          </v-col>
        </v-row>

        <span class="title"> Opciones SMS</span>
        <v-divider></v-divider>
        <v-row dense>
          <v-col cols="2">
            <v-switch
              label="Enviar SMS"
              v-model="filtro.enviarSms"
              color="indigo"></v-switch>
          </v-col>
          <v-col cols="4" v-if="filtro.enviarSms">
            <v-autocomplete
              v-model="filtro.modeloSmsId"
              :items="listModelosSms"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Modelo SMS"></v-autocomplete>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="2"> </v-col>
          <v-col cols="2" v-if="filtro.enviarSms">
            <v-autocomplete
              v-model="filtro.perteneceAId2"
              :items="listPerteneceA2"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Segunda Pertenencia"
              placeholder="Seleccione uno"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col cols="2" v-if="filtro.enviarSms">
            <v-autocomplete
              v-model="filtro.perteneceAId3"
              :items="listPerteneceA3"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Tercera Pertenencia"
              placeholder="Seleccione uno"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="2"> </v-col>
          <v-col cols="4" v-if="filtro.enviarSms">
            <v-autocomplete
              v-model="filtro.personasEmpleoId"
              :items="listSitLaboral"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Situacion Laboral"
              placeholder="Seleccione uno"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="2"> </v-col>
          <v-col cols="4" v-if="filtro.enviarSms">
            <v-radio-group
              v-model="filtro.debitoEnCuenta"
              :mandatory="true"
              row>
              <v-radio value="2">
                <div slot="label">Ambos</div>
              </v-radio>
              <v-radio value="1">
                <div slot="label">Con Tilde</div>
              </v-radio>
              <v-radio value="0">
                <div slot="label">Sin Tilde</div>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="2"> </v-col>
          <v-col cols="4" v-if="filtro.enviarSms">
            <v-radio-group
              v-model="filtro.categoriaPlanes"
              :mandatory="true"
              row>
              <v-radio value="0">
                <div slot="label">Indistinto</div>
              </v-radio>
              <v-radio value="1">
                <div slot="label">Barrido</div>
              </v-radio>
              <v-radio value="2">
                <div slot="label">Camara</div>
              </v-radio>
              <v-radio value="3">
                <div slot="label">PV</div>
              </v-radio>
              <v-radio value="4">
                <div slot="label">Codigo</div>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <!-- <v-row v-if="archivoFiltroOperaciones != null">
          <v-col>
            <v-chip v-if="operacionesFiltro.id == ''" label color="warning">
              Presione Cargar Filtro para procesar el archivo
            </v-chip>

   
          </v-col>
        </v-row> -->
      </v-card-text>

      <v-card-actions>
        <v-btn dark color="green" @click="procesar">
          Descargar&nbsp;
          <v-icon>cloud_download</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn dark color="green" @click="EnviarSms"> Enviar SMS&nbsp; </v-btn>
      </v-card-actions>
    </v-card>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>
<script>
import { http } from "@/axios";
import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      loading: false,
      filtro: {
        empresaId: 1,
        //sucursalesIds: [],
        canalesVentaIds: [],
        productosIds: [],
        perteneceAId: 0,
        perteneceAId2: 1,
        perteneceAId3: 1,
        acuerdo: 0,
        tipoTelefonoId: 2,
        porFecha: 1,
        enviarSms: false,
        fechaDesde: null,
        fechaHasta: null,
        fechaPagoDesde: null,
        fechaPagoHasta: null,
        modeloSmsId: 0,
        personasEmpleoId: 0,
        debitoEnCuenta: 2,
        categoriaPlanes: 0,
        vectorMoraDesde: 0,
        vectorMoraHasta: 0,
        porEstudio: false,
        porArchivo: false,
        estudios: [],
        porVencimientoAcuerdo: false,
        fechaVencimientoAcuerdoDesde: null,
        fechaVencimientoAcuerdoHasta: null,
        porCapital: false,
        capitalDesde: 0,
        capitalHasta: 0,
        porDiaCobro: false,
        diaCobroDesde: 0,
        diaCobroHasta: 0,
        separador: ";",
      },

      listEmpresas: [],
      listSucursales: [],
      listProductos: [],
      listPerteneceA: [],
      listPerteneceA2: [],
      listPerteneceA3: [],
      listModelosSms: [],
      listSitLaboral: [],
      listTiposCanalVenta: [],
      listEstudios: [],
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadSucursales();
    this.loadProductos();
    this.loadPerteneceA();
    this.loadModelosSMS();
    this.loadSitLaborales();
    this.loadEstudios();
    this.loadTiposCanalVenta();

    this.filtro.fechaDesde = this.$moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.filtro.fechaHasta = this.$moment(new Date()).format("YYYY-MM-DD");
    this.filtro.fechaPagoDesde = this.$moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.filtro.fechaPagoHasta = this.$moment(new Date()).format("YYYY-MM-DD");

    this.filtro.fechaVencimientoAcuerdoDesde = this.$moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.filtro.fechaVencimientoAcuerdoHasta = this.$moment(new Date()).format(
      "YYYY-MM-DD"
    );
  },
  computed: {
    ...mapGetters([
      "activeTask",
      "getActionFromLink",
      "user",
      "closeRelatedTasks",
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    componentsLoading: function () {
      return (
        this.loadingCreditosEnMora ||
        this.loadingTelefonos ||
        this.loadingGestionesTelefonicas ||
        this.loadingOtrasGestiones
      );
    },

    todosLosCanalesMarcados() {
      return (
        this.filtro.canalesVentaIds.length === this.listTiposCanalVenta.length
      );
    },
    algunosCanalesMarcados() {
      return (
        this.filtro.canalesVentaIds.length > 0 && !this.todosLosCanalesMarcados
      );
    },

    // todasLasSucursalesMarcadas() {
    //   return this.filtro.sucursalesIds.length === this.listSucursales.length;
    // },
    // algunasSucursalesMarcadas() {
    //   return (
    //     this.filtro.sucursalesIds.length > 0 && !this.todasLasSucursalesMarcadas
    //   );
    // },
    iconSucursales() {
      if (this.todasLasSucursalesMarcadas) return "mdi-close-box";
      if (this.algunasSucursalesMarcadas) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    todosLosProductosMarcados() {
      return this.filtro.productosIds.length === this.listProductos.length;
    },
    algunosProductosMarcados() {
      return (
        this.filtro.productosIds.length > 0 && !this.todosLosProductosMarcados
      );
    },
    iconProductos() {
      if (this.todosLosProductosMarcados) return "mdi-close-box";
      if (this.algunosProductosMarcados) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          "empresas/list/porusuario?usuarioId=" + this.user.id
        );
        this.listEmpresas = result.list;
        this.listEmpresas.unshift({ id: 0, nombre: "(Todas)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get(
          "sucursales/list/porusuario?usuarioId=" + this.user.id
        );

        this.listSucursales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    toggleSucursales() {
      this.$nextTick(() => {
        if (this.todasLasSucursalesMarcadas) {
          this.filtro.sucursalesIds = [];
        } else {
          this.filtro.sucursalesIds = this.listSucursales.map(function (p) {
            return p.id;
          });
        }
      });
    },

    async loadProductos() {
      this.loading = true;
      try {
        var result = await http.get("productos/");

        this.listProductos = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    toggleProductos() {
      this.$nextTick(() => {
        if (this.todosLosProductosMarcados) {
          this.filtro.productosIds = [];
        } else {
          this.filtro.productosIds = this.listProductos.map(function (p) {
            return p.id;
          });
        }
      });
    },

    async loadPerteneceA() {
      this.loading = true;
      try {
        var result = await http.get("tipostelefonopertenencia"); // traigo todas
        this.listPerteneceA = result.list;
        this.listPerteneceA.unshift({ id: 0, descripcion: "(Indistinto)" });
        this.listPerteneceA2 = result.list;
        this.listPerteneceA3 = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadModelosSMS() {
      this.loading = true;
      try {
        var result = await http.get("modelossms");
        this.listModelosSms = result.list;
        this.listModelosSms.unshift({ id: 0, descripcion: "(Ninguno)" });
        //this.listModelosSms = result.list.filter(x => x.tipoGestionId == 4);//modelos para tipo de gestión débitos por CBU
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadSitLaborales() {
      this.loading = true;
      try {
        var result = await http.get("situacioneslaborales");
        this.listSitLaboral = result.list;
        this.listSitLaboral.unshift({ id: 0, descripcion: "(Ambos)" });
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    // async loadCanalesVenta() {
    //   this.loading = true;
    //   try {
    //     var result = await http.get("canalesventa?limit=9999");

    //     this.listCanalesVenta = result.list;
    //   } catch (error) {
    //     // Error
    //     this.alertError(error);
    //   }
    //   this.loading = false;
    // },

    async loadTiposCanalVenta() {
      this.loading = true;
      try {
        var result = await http.get("tiposcanalventa");
        this.listTiposCanalVenta = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },

    toggleCanales() {
      this.$nextTick(() => {
        if (this.todosLosCanalesMarcados) {
          this.filtro.canalesVentaIds = [];
        } else {
          this.filtro.canalesVentaIds = this.listTiposCanalVenta.map(function (
            p
          ) {
            return p.id;
          });
        }
      });
    },

    async loadEstudios() {
      this.loading = true;
      try {
        var result = await http.get("estudiosexternos");

        this.listEstudios = result.list;
        this.listEstudios.unshift({ id: 0, descripcion: "(Todos)" });

        this.filtro.estudios = [];
        this.filtro.estudios.push(0);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    // async traerListaOperacionesDeExcel() {
    //   if (!this.archivoFiltroOperaciones) return;
    //   if (!this.archivoFiltroOperaciones.name.includes(".xls")) {
    //     this.archivoFiltroOperaciones = [];
    //     this.alertWarning("Debe elegir un archivo Excel.");
    //     return;
    //   }

    //   this.loading = true;
    //   let formData = new FormData();

    //   formData.append("archivo", this.archivoFiltroOperaciones);

    //   try {
    //     var listaOps = await http.post(
    //       "archivosDebito/excelAFiltroOperaciones",
    //       formData
    //     );
    //     console.log(listaOps);
    //     this.operacionesFiltro = listaOps;
    //     this.radiosArchivoExcel = "SoloCasosFiltro";
    //   } catch (error) {
    //     // Error
    //     this.alertError(error);
    //   }

    //   /* http.post('archivosDebito/excelAFiltroOperaciones', formData)
    //     .then(resp => {
    //         Vue.$log.debug(resp);
    //     })
    //     .catch((e) => {
    //         this.alertError(e)
    //     }); */

    //   this.loading = false;
    // },

    async procesar() {
      // validaciones
      // if(this.filtro.empresaId === 0)
      // {
      //     this.alertWarning('Debe seleccionar una Empresa.');
      //     return;
      // }

      var self = this;

      try {
        self.loading = true;

        var filtros = Object.assign({}, this.filtro);
        filtros.estudios = this.filtro.estudios.toString();

        let formData = new FormData();
        formData.append("excelFile", this.archivoFiltroOperaciones);
        formData.append("empresaId", this.filtro.empresaId);
        formData.append("canalesVentaIds", this.filtro.canalesVentaIds);
        formData.append("productosIds", this.filtro.productosIds);
        formData.append("perteneceAId", this.filtro.perteneceAId);
        formData.append("perteneceAId2", this.filtro.perteneceAId2);
        formData.append("perteneceAId3", this.filtro.perteneceAId3);
        formData.append("acuerdo", this.filtro.acuerdo);
        formData.append("tipoTelefonoId", this.filtro.tipoTelefonoId);
        formData.append("porFecha", this.filtro.porFecha);
        formData.append("enviarSms", this.filtro.enviarSms);
        formData.append("fechaDesde", this.filtro.fechaDesde);
        formData.append("fechaHasta", this.filtro.fechaHasta);
        formData.append("fechaPagoDesde", this.filtro.fechaPagoDesde);
        formData.append("fechaPagoHasta", this.filtro.fechaPagoHasta);
        formData.append("modeloSmsId", this.filtro.modeloSmsId);
        formData.append("personasEmpleoId", this.filtro.personasEmpleoId);
        formData.append("debitoEnCuenta", this.filtro.debitoEnCuenta);
        formData.append("categoriaPlanes", this.filtro.categoriaPlanes);
        formData.append("vectorMoraDesde", this.filtro.vectorMoraDesde);
        formData.append("vectorMoraHasta", this.filtro.vectorMoraHasta);
        formData.append("porEstudio", this.filtro.porEstudio);
        formData.append("estudios", this.filtro.estudios);

        formData.append(
          "porVencimientoAcuerdo",
          this.filtro.porVencimientoAcuerdo
        );
        formData.append(
          "fechaVencimientoAcuerdoDesde",
          this.filtro.fechaVencimientoAcuerdoDesde
        );
        formData.append(
          "fechaVencimientoAcuerdoHasta",
          this.filtro.fechaVencimientoAcuerdoHasta
        );

        formData.append("porCapital", this.filtro.porCapital);
        formData.append("capitalDesde", this.filtro.capitalDesde);
        formData.append("capitalHasta", this.filtro.capitalHasta);
        formData.append("porDiaCobro", this.filtro.porDiaCobro);
        formData.append("diaCobroDesde", this.filtro.diaCobroDesde);
        formData.append("diaCobroHasta", this.filtro.diaCobroHasta);
        formData.append("porArchivo", this.filtro.porArchivo);
        formData.append("separador", this.filtro.separador);
        console.log(JSON.stringify({ parametros: filtros }));
        //alert(this.archivoFiltroOperaciones);
        await http
          .post("filegeneration/baseivr", formData)

          // .post(
          //   "filegeneration/baseivr",
          //   JSON.stringify({ parametros: filtros })

          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se generó correctamente el archivo. Aguarde unos instantese mientras se descarga el archivo..."
              );

              self.loading = true;
              self.downloadFile(resp, "BaseIVR.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },

    async downloadFile(file, renameTo) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = "";
      base64String = btoa(file.fullPath);

      http
        .get("filemanagement/getfilebypath/" + base64String)
        .then((resp) => {
          let dataType = "";
          switch (resp.extension) {
            case ".doc":
            case ".docx":
            case ".DOC":
            case ".DOCX":
              dataType = "data:application/vnd.ms-word";
              break;
            case ".pdf":
            case ".PDF":
              dataType = "data:application/pdf";
          }

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(renameTo, arrayBuffer, dataType);
        })
        .catch((e) => this.alertError(e));
    },
    async EnviarSms() {
      // validaciones
      // if(this.filtro.empresaId === 0)
      // {
      //     this.alertWarning('Debe seleccionar una Empresa.');
      //     return;
      // }

      let formData = new FormData();
      formData.append("excelFile", this.archivoFiltroOperaciones);
      formData.append("empresaId", this.filtro.empresaId);
      formData.append("canalesVentaIds", this.filtro.canalesVentaIds);
      formData.append("productosIds", this.filtro.productosIds);
      formData.append("perteneceAId", this.filtro.perteneceAId);
      formData.append("perteneceAId2", this.filtro.perteneceAId2);
      formData.append("perteneceAId3", this.filtro.perteneceAId3);
      formData.append("acuerdo", this.filtro.acuerdo);
      formData.append("tipoTelefonoId", this.filtro.tipoTelefonoId);
      formData.append("porFecha", this.filtro.porFecha);
      formData.append("enviarSms", this.filtro.enviarSms);
      formData.append("fechaDesde", this.filtro.fechaDesde);
      formData.append("fechaHasta", this.filtro.fechaHasta);
      formData.append("fechaPagoDesde", this.filtro.fechaPagoDesde);
      formData.append("fechaPagoHasta", this.filtro.fechaPagoHasta);
      formData.append("modeloSmsId", this.filtro.modeloSmsId);
      formData.append("personasEmpleoId", this.filtro.personasEmpleoId);
      formData.append("debitoEnCuenta", this.filtro.debitoEnCuenta);
      formData.append("categoriaPlanes", this.filtro.categoriaPlanes);
      formData.append("vectorMoraDesde", this.filtro.vectorMoraDesde);
      formData.append("vectorMoraHasta", this.filtro.vectorMoraHasta);
      formData.append("porEstudio", this.filtro.porEstudio);
      formData.append("estudios", this.filtro.estudios);
      formData.append(
        "porVencimientoAcuerdo",
        this.filtro.porVencimientoAcuerdo
      );
      formData.append(
        "fechaVencimientoAcuerdoDesde",
        this.filtro.fechaVencimientoAcuerdoDesde
      );
      formData.append(
        "fechaVencimientoAcuerdoHasta",
        this.filtro.fechaVencimientoAcuerdoHasta
      );

      formData.append("porCapital", this.filtro.porCapital);
      formData.append("capitalDesde", this.filtro.capitalDesde);
      formData.append("capitalHasta", this.filtro.capitalHasta);
      formData.append("porDiaCobro", this.filtro.porDiaCobro);
      formData.append("diaCobroDesde", this.filtro.diaCobroDesde);
      formData.append("diaCobroHasta", this.filtro.diaCobroHasta);
      formData.append("separador", this.filtro.separador);
      formData.append("porArchivo", this.filtro.porArchivo);

      console.log(JSON.stringify({ parametros: filtros }));
      var self = this;

      try {
        self.loading = true;

        var filtros = Object.assign({}, this.filtro);
        filtros.estudios = this.filtro.estudios.toString();

        await http
          .post("gestion/baseivrsms", formData)

          //JSON.stringify({ parametros: filtros }))
          .then((resp) => {
            //console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se enviaron correctamente los sms.");

              self.loading = true;
              //self.downloadFile(resp, 'BaseCompletaDiaria.csv');
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
  },
};
</script>
